// Imports
var ___HTML_LOADER_GET_SOURCE_FROM_IMPORT___ = require("../../node_modules/html-loader/dist/runtime/getUrl.js");
var ___HTML_LOADER_IMPORT_0___ = require("../../assets/images/pdf/patientCard/patientCard.png");
// Module
var ___HTML_LOADER_REPLACEMENT_0___ = ___HTML_LOADER_GET_SOURCE_FROM_IMPORT___(___HTML_LOADER_IMPORT_0___);
var code = "\n<button class=\"close content-fadeIn\" id=\"close_btn_patientCard\"></button>\n<div class='popup-content sumnmaryPatientCard'>\n    <div class=\"inner-content\">\n\n        <img src=\"" + ___HTML_LOADER_REPLACEMENT_0___ + "\" class=\"\" /> \n\n    </div>\n  \n\n</div>\n\n\n\n ";
// Exports
module.exports = code;